module.exports = __webpack_public_path__ + "VIPG1.png?cca8b2b43c5380d1bf0d0f1ab42ae52f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/greyhounds/VIPG1.png
// module id = 73
// module chunks = 0